/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/inputValidator.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'shared/inputValidator', exports: {} }; const exports = module.exports;

import { Fandango as Fandango_context } from '@grins/fd-modules/splits/require-core';

const { context: { passwordValidation } } = Fandango_context;
import $ from '@grins/fd-modules/jQuery';

import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';

const RegExes = {
  // #region RULES
  SYMBOL_OR_NUMBER: /[0-9,!@#$%^&*()|?:;+=".<>]+/,
  VALID_EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
  // #endregion

  MSG_REPLACE: /{{name}}/gi,
};

const ValidationTypes = {
  CUSTOM: 'none',
  NAMES: 'firstOrLastName',
  EMAIL: 'email',
  PASSWORD: 'password',
  ZIP: 'zipCode',
  BILLING_POSTAL_CODE: 'billingPostalCode'
};

const Presets = {
  [ValidationTypes.NAMES]: {
    displayName: 'Name',
    failRules: [{
      regex: RegExes.SYMBOL_OR_NUMBER,
      msg: '{{name}} cannot contain symbols or numbers.'
    }]
  },
  [ValidationTypes.EMAIL]: {
    displayName: 'Email',
    passRules: [{
      regex: RegExes.VALID_EMAIL,
      msg: 'Please enter a valid email address.'
    }]
  },
  [ValidationTypes.PASSWORD]: {
    displayName: 'Password',
  },
  [ValidationTypes.ZIP]: {
    displayName: 'Postcode',
    passRules: [{
      regex: '^[A-Za-z]{1,2}[0-9][0-9A-Za-z]?\\s?[0-9][A-Za-z]{2}$',
      msg: 'Please enter a valid Postcode.'
    }]
  },
  [ValidationTypes.BILLING_POSTAL_CODE]: {
    displayName: 'Billing Postcode',
    passRules: [{
      // Braintree's 4-9 alphanumeric characters, optionally with hyphens or spaces
      regex: '^[A-Za-z0-9](?=(?:[^A-Za-z0-9]*[A-Za-z0-9]){3,8}[^A-Za-z0-9]*$)[A-Za-z0-9 -]*[A-Za-z0-9]$',
      msg: 'Please enter a valid Billing Postcode.'
    }]
  },
};

let passwordRulesImported = false;
function importPasswordRules(rules) {
  if (!rules) {
    return debugLog.warn(module.name, 'Password rules not found');
  }

  if (passwordRulesImported) {
    return;
  }

  passwordRulesImported = true;
  Presets[ValidationTypes.PASSWORD].failRules = rules.map(({ regEx, msg }) => ({ regex: regEx, msg }));
}

function applyRegExTests(value, tests, displayName, successCondition) {
  return tests
    .filter(rule => rule && rule.regex && rule.msg)
    .reduce((error, { regex, msg }) => {
      if (error) {
        return error;
      }

      regex = typeof regex === 'string' ? new RegExp(regex, 'i') : regex;
      return regex.test(value) === successCondition ? msg.replace(RegExes.MSG_REPLACE, displayName) : '';
    }, '');
}

/**
 * we'll be attempting to merge any custom rules provided along with the Preset (if specified)
 * @param {Object} rule
 */
function normalizeValidationRule(rule) {
  const $input = rule.$input || $(rule.input);
  const { type } = rule;

  // TODO: input type "text" or "textarea" only right now.
  // TODO: is it OK to trim a password??
  let value = $.trim($input.val());

  if (type === ValidationTypes.EMAIL) {
    value = value.toLowerCase();
  }

  const preset = Presets[type] || {};
  return {
    $input,
    displayName: rule.displayName || preset.displayName || '',
    failRules: [].concat(preset.failRules, rule.failRules),
    isRequired: Boolean(typeof rule.isRequired === 'boolean' ? rule.isRequired : preset.isRequired),
    name: rule.name || $input.attr('name') || `unnamed-${Math.round(9999 * Math.random())}`,
    passRules: [].concat(preset.passRules, rule.passRules),
    value,
  };
}

function validate(data) {
  const errors = [];
  const results = {};

  importPasswordRules(passwordValidation && passwordValidation.rules);

  data.forEach((rule) => {
    const { $input, displayName, failRules, isRequired, name, passRules, value } = normalizeValidationRule(rule);

    if (isRequired && !value) {
      return errors.push({
        $input,
        error: `${displayName} is required.`,
      });
    }

    // TODO: fix cases when `isRequired` is `false` that we might bypass regular expression check
    let error;

    // let's loop over all "positive tests", if value doesn't match the RegEx rule the value has failed and we log the error.
    // ex. "email addresses must contain the '@' character"
    error = applyRegExTests(value, passRules, displayName, false);
    if (error) {
      return errors.push({ $input, error });
    }

    // now same drill for "negative tests", if value contains some forbidden character or otherwise fails to satisfy the RegEx it is logged as an error.
    // ex. "a person's first name may not begin with a number"
    error = applyRegExTests(value, failRules, displayName, true);
    if (error) {
      return errors.push({ $input, error });
    }

    // we've passed all the tests so we add to our results
    results[name] = value;
  });

  if (errors.length) {
    Object.assign(results, {
      hasErrors: true,
      errors,
    });
  }

  return results;
}

export default {
    ValidationTypes,
    validate,
};
